import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CarpentryIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 297 297"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M45.72,152.624c-5.946,0.956-11.419,3.729-15.744,8.053L8.431,182.222C2.994,187.66,0,194.908,0,202.633c0,7.725,2.994,14.973,8.431,20.409l50.8,50.8c5.436,5.436,12.684,8.43,20.409,8.43s14.973-2.993,20.41-8.43l21.544-21.545c4.441-4.44,7.115-9.979,8.05-15.75L45.72,152.624z M84.402,236.65c-1.314,1.314-3.039,1.972-4.762,1.972c-1.724,0-3.447-0.658-4.763-1.973l-29.254-29.255c-2.63-2.63-2.63-6.894,0.001-9.524c2.63-2.629,6.895-2.629,9.524,0.001l29.254,29.255C87.033,229.755,87.033,234.019,84.402,236.65z" />
    <path d="M292.169,50.968l-60.892-34.963c-3.498-2.009-7.876-1.622-10.968,0.967L61.817,149.67l71.657,71.657l3.434-8.565l15.91-6.378c2.439-0.978,4.372-2.912,5.35-5.351l6.375-15.906l15.904-6.374c2.44-0.978,4.374-2.912,5.352-5.352l6.374-15.905l15.905-6.374c2.441-0.978,4.375-2.912,5.352-5.352l6.373-15.903l15.902-6.373c2.441-0.978,4.375-2.912,5.353-5.353l6.369-15.9l15.903-6.372c2.44-0.978,4.375-2.912,5.352-5.352l6.371-15.901l15.903-6.373c3.423-1.372,5.761-4.579,6.019-8.258C297.235,56.306,295.367,52.804,292.169,50.968z" />
  </svg>
)
const ForwardRef = forwardRef(CarpentryIcon)
export { ForwardRef as ReactComponent }
